import React, { useEffect, useState } from 'react'
import { Pagination, Popconfirm, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDebounce } from 'use-debounce'
import Notifications from '../../../helpers/Notifications'
import { reOrgStatusTypeActions } from './store/actions'
import dayjs from "dayjs"
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import AddIcon from '../../../components/Icons/add.svg'
import ReOrgStatusTypeChangeForm from "./change"
import LocalLoading from '../../../components/Loading/Local'
import ModalAudit from '../ModalAudit'
import { useTranslation } from "react-i18next"
import api from "./store/api"

const ReOrgStatusType = (props) => {
	const { isModify = false } = props
	const pageSize = 10
	const [visible, setVisible] = useState(false)
	const [record, setRecord] = useState(null)
	const [count, setCount] = useState(0)
	const [visibleAudit, setVisibleAudit] = useState(false)
	const [idRecordAudit, setIdRecordAudit] = useState(null)
	const [table, setTable] = useState([])
	const [page, setPage] = useState(1)
	const [search, setSearch] = useState(null)
	const [searchValue] = useDebounce(search, 500)
	const { isSending, changed, paged } = useSelector((state) => state.reOrgStatusTypeReducer)
	const {t} = useTranslation(['common', 'valid', 'action'])
	const dispatch = useDispatch()

	const getPaged = params => {
		dispatch(reOrgStatusTypeActions.getPaged(params))
	}
	const getPagedAll = params => {
		dispatch(reOrgStatusTypeActions.getPagedAll(params))
	}
	const create = params => {
		dispatch(reOrgStatusTypeActions.create(params))
	}
	const remove = params => {
		dispatch(reOrgStatusTypeActions.remove(params))
	}
	const update = params => {
		dispatch(reOrgStatusTypeActions.update(params))
	}
	const restore = params => {
		dispatch(reOrgStatusTypeActions.restore(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reOrgStatusTypeActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	function onPaginationChange(value){
		setPage(value)
		const params = {
			name     : searchValue?.trim(),
			pageSize : pageSize,
			page     : value
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	const comColumns = [
		{
			title     : t('common:code'),
			dataIndex : 'code',
			key       : 'code'
		},
		{
			title     : t('common:name'),
			dataIndex : 'name',
			key       : 'name'
		}
	]

	const manageColumns = [
		...comColumns,
		{
			title     : t('common:dateCreate'),
			dataIndex : 'createDate',
			key       : 'createDate',
			render    : (date) => dayjs(date).format("DD.MM.YYYY")
		},
		{
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img alt=""
						src={UpdateIcon}
						title={t('edit')}
						onClick={() => {
							setVisible(true)
							setRecord(record)
						}}
					/>
					<Popconfirm
						cancelText={t('no')}
						okText={t('yes')}
						placement="left"
						title={!record.isDeleted ? t('valid:sureToDelete') : t('valid:sureToRestore')}
						onCancel={(e) => {
							e.stopPropagation()
							return null
						}}
						onConfirm={(e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						}}
					>
						<img alt=""
							src={!record.isDeleted ? DeleteIcon : RestoreIcon}
							title={!record.isDeleted ? t('action:delete') : t('action:restore')}
						/>
					</Popconfirm>
					<img alt=""
						className="audit-icon-svg"
						src={AuditIcon}
						title={t('common:historyOfChange')}
						onClick={() => {
							setVisibleAudit(true)
							setIdRecordAudit(id)
						}}
					/>
				</div>
			)
		}
	]

	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={64}
					placeholder={t('action:enterNameCode')}
					onChange={(e) => setSearch(e.target.value)}
				/>
				{isModify
					? (
						<CustomButton
							className="add-nsi"
							type="green"
							onClick={() => {
								setRecord(null)
								setVisible(true)
							}}
						>
							<div>
								<img alt="" src={AddIcon}/>
								<span>{t('action:add')}</span>
							</div>
						</CustomButton>
					)
					: null
				}
			</div>
			<Table
				columns={isModify ? manageColumns : comColumns}
				dataSource={table?.map((el, idx) => ({key: el.code, ...el}))}
				loading={{indicator: <LocalLoading/>, spinning: isSending}}
				pagination={false}
				scroll={{x: 1100}}
			/>
			{
				count > pageSize &&
				<Pagination
					showQuickJumper
					current={page}
					pageSize={pageSize}
					showSizeChanger={false}
					size="small"
					total={count}
					onChange={onPaginationChange}
				/>
			}
			{isModify &&
				<ReOrgStatusTypeChangeForm
					create={create}
					record={record}
					setRecord={setRecord}
					setVisible={setVisible}
					update={update}
					visible={visible}
				/>
			}
			<ModalAudit
				columns={comColumns}
				setIdRecordAudit={setIdRecordAudit}
				idRecordAudit={idRecordAudit}
				setVisible={setVisibleAudit}
				visible={visibleAudit}
				pageSize={pageSize}
				func={api.getPagedAudit}
			/>
		</>
	)
}

export default ReOrgStatusType